module.exports = __webpack_public_path__ + "Roboto-Thin.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.eot
// module id = 31
// module chunks = 0